import { GET_FOOD_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_FOOD_TYPES_SUCCESS: {
      const foodTypes = action.payload;

      if (!foodTypes){
        return [...state];
      }

      return [
        ...state,
        ...foodTypes
      ]
    }
    default:
      return state;
  }
}
